import { confirmar } from '@/libs/cifra/dialogs';
import { t } from '@/libs/i18n';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    const { estado } = this.element.dataset;

    if (estado === 'necesita_pago') {
      confirmar({
        title: t('pago_obligatorio'),
        showCancelButton: false,
        text: t('pago_obligatorio_aviso'),
      });
    }
  }
}
